namespace SP {


    export interface CustomsInfo {
        id: string;
        itemId: string;
        description: string;
        totalPrice: number;
        currencyCode: string;
        senderTariff: string;
        receiverTariff: string;
        originCountry: string;
        weight: number;
    }
}